/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_50k_CreditsInputs */

const en_landing_pricing_feature_50k_credits = /** @type {(inputs: Landing_Pricing_Feature_50k_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`50,000 credits`)
};

const zh_landing_pricing_feature_50k_credits = /** @type {(inputs: Landing_Pricing_Feature_50k_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`50,000 积分`)
};

/**
* | output |
* | --- |
* | "50,000 credits" |
*
* @param {Landing_Pricing_Feature_50k_CreditsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_50k_credits = /** @type {((inputs?: Landing_Pricing_Feature_50k_CreditsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_50k_CreditsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_50k_credits(inputs)
	return zh_landing_pricing_feature_50k_credits(inputs)
});
export { landing_pricing_feature_50k_credits as "landing.pricing.feature_50k_credits" }